import { JsonObject, JsonProperty } from 'json-ts-mapper';

@JsonObject
export class Banniere {
  constructor (
    id?: number,
    title?: string,
    mediaLink?: string,
    status?: boolean
  ) {
    this.id = id as any;
    this.title = title as any;
    this.mediaLink = mediaLink as any;
    this.status = status as any;
  }

  @JsonProperty(Number)
  id: number;

  @JsonProperty(String)
  title: string;

  @JsonProperty(String)
  mediaLink: string;

  @JsonProperty(Boolean)
  status: boolean;
}
